import {
    FETCH_MESSAGES,
    FETCH_MESSAGES_SUCCESS,
    FETCH_MESSAGES_FAILED,
    SEND_MESSAGE,
    STOP_FETCH_MESSAGES,
    CHAT_UNREAD_COUNT,
    CHAT_UNREAD_RESET,
} from "../store/types";
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { RequestPushMsg } from '../other/NotificationFunctions';
import { onValue, push, child, set } from "firebase/database";

const messageListeners = {};
const unreadListeners = {};

const parseMessagesSnapshot = (snapshot) => {
    if (!snapshot.val()) return [];
    const rootEntry = snapshot.val();
    const allMesseges = [];
    for (const key in rootEntry) {
        const entryKey = rootEntry[key];
        for (const msgKey in entryKey) {
            entryKey[msgKey].smsId = msgKey;
            allMesseges.push(entryKey[msgKey]);
        }
    }
    return allMesseges;
};

const countUnread = (messages, currentUid, lastReadAt) => {
    const lastReadMs = lastReadAt ? new Date(lastReadAt).getTime() : 0;
    return messages.filter((m) => {
        if (!m || m.from === currentUid) return false;
        const createdMs = m.createdAt ? new Date(m.createdAt).getTime() : 0;
        return createdMs > lastReadMs;
    }).length;
};

export const fetchChatMessages = (bookingId) => (dispatch) => {
    const { chatRef } = firebase;

    dispatch({
        type: FETCH_MESSAGES,
        payload: bookingId,
    });

    if (messageListeners[bookingId]) {
        messageListeners[bookingId]();
    }

    messageListeners[bookingId] = onValue(chatRef(bookingId), (snapshot) => {
        if (snapshot.val()) {
            dispatch({
                type: FETCH_MESSAGES_SUCCESS,
                payload: parseMessagesSnapshot(snapshot),
            });
        } else {
            dispatch({
                type: FETCH_MESSAGES_FAILED,
                payload: store.getState().languagedata.defaultLanguage.chat_not_found,
            });
        }
    });
};

export const sendMessage = (data) => (dispatch) => {
    const { chatRef } = firebase;

    const chatId = data.booking.customer + ','  + data.booking.driver
    var today = new Date();
    var time = today.getHours() + ":" + today.getMinutes();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); 
    var yyyy = today.getFullYear();
    today = mm + ':' + dd + ':' + yyyy;
    
    const msg = {
        message:data.message,
        from: data.role == 'customer'? data.booking.customer : data.booking.driver,
        type:"msg",
        msgDate:today,
        msgTime:time,
        createdAt: new Date().toString(),
        source: data.role
    };

    push(child(chatRef(data.booking.id), chatId), msg);

    if(data.role == 'customer'){
        if(data.booking.driver_token){
            RequestPushMsg(
                data.booking.driver_token,
                {
                    title: store.getState().languagedata.defaultLanguage.notification_title  + store.getState().languagedata.defaultLanguage.chat_requested,
                    msg: data.message,
                    screen: 'onlineChat',
                    params: { bookingId: data.booking.id }
                });
        }
    }else{
        if(data.booking.customer_token){
            RequestPushMsg(
                data.booking.customer_token,
                {
                    title: store.getState().languagedata.defaultLanguage.notification_title  + store.getState().languagedata.defaultLanguage.chat_requested,
                    msg: data.message,
                    screen: 'onlineChat',
                    params: { bookingId: data.booking.id}
                });
        }
    }

    dispatch({
        type: SEND_MESSAGE,
        payload: msg,
    });
}

export const stopFetchMessages = (bookingId) => (dispatch) => {
    if (messageListeners[bookingId]) {
        messageListeners[bookingId]();
        delete messageListeners[bookingId];
    }

    dispatch({
        type: STOP_FETCH_MESSAGES,
        payload: bookingId,
    });
};

export const watchChatUnread = (bookingId, uid) => (dispatch) => {
    const { chatRef, chatReadRef } = firebase;
    const listenerKey = `${bookingId}_${uid}`;

    if (unreadListeners[listenerKey]) {
        unreadListeners[listenerKey]();
    }

    let messages = [];
    let lastReadAt = null;

    const publishUnread = () => {
        dispatch({
            type: CHAT_UNREAD_COUNT,
            payload: {
                bookingId,
                count: countUnread(messages, uid, lastReadAt),
            },
        });
    };

    const unsubMessages = onValue(chatRef(bookingId), (snapshot) => {
        messages = parseMessagesSnapshot(snapshot);
        publishUnread();
    });

    const unsubRead = onValue(chatReadRef(bookingId, uid), (snapshot) => {
        lastReadAt = snapshot.val()?.lastReadAt || null;
        publishUnread();
    });

    unreadListeners[listenerKey] = () => {
        unsubMessages();
        unsubRead();
    };
};

export const unwatchChatUnread = (bookingId, uid) => (dispatch) => {
    const listenerKey = `${bookingId}_${uid}`;
    if (unreadListeners[listenerKey]) {
        unreadListeners[listenerKey]();
        delete unreadListeners[listenerKey];
    }
    dispatch({
        type: CHAT_UNREAD_RESET,
        payload: bookingId,
    });
};

export const markChatAsRead = (bookingId, uid) => (dispatch) => {
    const { chatReadRef } = firebase;
    set(chatReadRef(bookingId, uid), {
        lastReadAt: new Date().toISOString(),
    });
    dispatch({
        type: CHAT_UNREAD_COUNT,
        payload: { bookingId, count: 0 },
    });
};
